import projectRoutes from './project/project.routes.js';
import signRoutes from './sign/sign.routes.js';

export default {
  path: 'jc',
  name: 'jxxfJc',
  component: { template: '<router-view></router-view>' },
  children: [
    projectRoutes,
    {
      path: 'report/pending',
      name: 'jxxfJcPendingReportIndex',
      component: () => import('./report/jcBgList.vue'),
      meta: { navtabTitle: '待生成检测报告', isCache: true, ignoreDiff: [], menuElements: [] }
    },
    {
      path: 'report/index',
      name: 'jxxfJcReportIndex',
      component: () => import('./report/jcBgList.vue'),
      meta: { navtabTitle: '检测报告管理', isCache: true, ignoreDiff: [], menuElements: [] }
    },
    signRoutes
  ]
};
